import axios from "axios";

// Client Access Management API — shared, module-agnostic read-only access.
// Independent of the legacy Client Portal (lib/adminApi `axc`).
const ax = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/client-access`,
  withCredentials: true,
});

// Consultant / admin — manage access on a FINALIZED assignment.
export const grantClientAccess = (module, assignmentId, emails, message) =>
  ax
    .post("/grants", { module, assignment_id: assignmentId, emails, message })
    .then((r) => r.data);

export const listClientAccessGrants = (module, assignmentId) =>
  ax
    .get("/grants", { params: { module, assignment_id: assignmentId } })
    .then((r) => r.data.grants || []);

export const resendClientAccess = (grantId) =>
  ax.post(`/grants/${grantId}/resend`).then((r) => r.data);

export const revokeClientAccess = (grantId) =>
  ax.delete(`/grants/${grantId}`).then((r) => r.data);

// Client — my finalized assignments across modules.
export const getMyAssignments = () =>
  ax.get("/my-assignments").then((r) => r.data.assignments || []);

// Decide where a signed-in client should land. Client Access Management users
// (those with at least one active grant) go to My Evaluations; others fall back
// to their legacy destination (handled by the caller).
export const resolveClientLanding = async () => {
  try {
    const mine = await getMyAssignments();
    if (Array.isArray(mine) && mine.length > 0) return "/transformation/evaluations";
  } catch {
    /* ignore — caller falls back to legacy routing */
  }
  return null;
};

// Read-only access check for the reused detail pages.
export const getMyAccess = (module, assignmentId) =>
  ax
    .get("/access", { params: { module, assignment_id: assignmentId } })
    .then((r) => r.data);
